export const isValidEmailFormat = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const isEmailDomainAllowed = (
  email: string,
  whitelist: string[] | null
): boolean => {
  if (whitelist === null) return true;

  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;

  return whitelist.some((allowed) => allowed.toLowerCase() === domain);
};
